export default __webpack_public_path__ + "static/media/headshot_bubble.d23f6f4e.webp";